import { TakeTypeId as TakeTypeId$1, chunk as chunk$1, die as die$1, dieMessage as dieMessage$1, done as done$1, end as end$1, fail as fail$1, failCause as failCause$1, fromEffect as fromEffect$1, fromExit as fromExit$1, fromPull as fromPull$1, isDone as isDone$1, isFailure as isFailure$1, isSuccess as isSuccess$1, make as make$1, map as map$1, match as match$1, matchEffect as matchEffect$1, of as of$1, tap as tap$1 } from '../../internal/take.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TakeTypeId = TakeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `Take<E, A>` represents a single `take` from a queue modeling a stream of
 * values. A `Take` may be a failure cause `Cause<E>`, a chunk value `Chunk<A>`,
 * or an end-of-stream marker.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Creates a `Take` with the specified chunk.
 *
 * @since 2.0.0
 * @category constructors
 */
const chunk = chunk$1;

/**
 * Creates a failing `Take` with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
const die = die$1;

/**
 * Creates a failing `Take` with the specified error message.
 *
 * @since 2.0.0
 * @category constructors
 */
const dieMessage = dieMessage$1;

/**
 * Transforms a `Take<E, A>` to an `Effect<never, E, A>`.
 *
 * @since 2.0.0
 * @category destructors
 */
const done = done$1;

/**
 * Represents the end-of-stream marker.
 *
 * @since 2.0.0
 * @category constructors
 */
const end = end$1;

/**
 * Creates a failing `Take` with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
const fail = fail$1;

/**
 * Creates a failing `Take` with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
const failCause = failCause$1;

/**
 * Creates an effect from `Effect<R, E, A>` that does not fail, but succeeds with
 * the `Take<E, A>`. Error from stream when pulling is converted to
 * `Take.failCause`. Creates a single value chunk.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromEffect = fromEffect$1;

/**
 * Creates a `Take` from an `Exit`.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromExit = fromExit$1;

/**
 * Creates effect from `Effect<R, Option<E>, Chunk<A>>` that does not fail, but
 * succeeds with the `Take<E, A>`. Errors from stream when pulling are converted
 * to `Take.failCause`, and the end-of-stream is converted to `Take.end`.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromPull = fromPull$1;

/**
 * Checks if this `take` is done (`Take.end`).
 *
 * @since 2.0.0
 * @category getters
 */
const isDone = isDone$1;

/**
 * Checks if this `take` is a failure.
 *
 * @since 2.0.0
 * @category getters
 */
const isFailure = isFailure$1;

/**
 * Checks if this `take` is a success.
 *
 * @since 2.0.0
 * @category getters
 */
const isSuccess = isSuccess$1;

/**
 * Constructs a `Take`.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Transforms `Take<E, A>` to `Take<E, B>` by applying function `f`.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = map$1;

/**
 * Folds over the failure cause, success value and end-of-stream marker to
 * yield a value.
 *
 * @since 2.0.0
 * @category destructors
 */
const match = match$1;

/**
 * Effectful version of `Take.fold`.
 *
 * Folds over the failure cause, success value and end-of-stream marker to
 * yield an effect.
 *
 * @since 2.0.0
 * @category destructors
 */
const matchEffect = matchEffect$1;

/**
 * Creates a `Take` with a single value chunk.
 *
 * @since 2.0.0
 * @category constructors
 */
const of = of$1;

/**
 * Returns an effect that effectfully "peeks" at the success of this take.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tap = tap$1;

export { TakeTypeId, chunk, die, dieMessage, done, end, fail, failCause, fromEffect, fromExit, fromPull, isDone, isFailure, isSuccess, make, map, match, matchEffect, of, tap };
